module.exports = __webpack_public_path__ + "img/eric.23838935.svg";